import { helperConstants } from "./helperConstants";

const supportedChains = helperConstants.helpers.supportedChains;

export const getSupportedChain = (chain) => {
  return supportedChains.find((c) => c.hexId === chain);
};
